import Link from "next/link";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

interface ReserveButtonProps {
  className?: string;
}

export const ReserveButton = ({ className = "" }: ReserveButtonProps) => {
  const t = useTranslations("buttons");

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
      className="w-fit"
    >
      <Link
        href="/reservation"
        className={`group relative flex items-center gap-2 overflow-hidden rounded-full bg-primary px-5 py-2.5 hover:cursor-pointer ${className}`}
      >
        {/* Effet de lumière qui passe */}
        <motion.div
          className="absolute inset-0 bg-white/20"
          initial={{ x: "-100%" }}
          whileHover={{ x: "100%" }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        />

        <motion.p
          className="relative text-base font-extralight uppercase tracking-wider text-white"
          whileHover={{ x: 4 }}
          transition={{ type: "spring", stiffness: 400, damping: 17 }}
        >
          {t("reserve")}
        </motion.p>

        <motion.div
          className="relative"
          animate={{
            y: [0, -2, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          whileHover={{
            x: 4,
            transition: { type: "spring", stiffness: 400, damping: 17 },
          }}
        >
          <Icon
            icon="material-symbols-light:arrow-cool-down-rounded"
            className="h-6 w-6 -rotate-90 text-white"
          />
        </motion.div>
      </Link>
    </motion.div>
  );
};
